import { handleGetChartData } from "@/api/chartAPI";

export default {
  state: {
    chartData: null,
  },

  mutations: {
    setChartData(state, payload) {
      state.chartData = payload;
    },
  },

  actions: {
    async fetchChartData({ commit }, payload) {
      commit("setDataLoading", true);
      try {
        await handleGetChartData(payload, (res) => {
          commit("setChartData", res);
        });
      } catch (err) {
        console.log(err);
        commit("setDataLoading", false);
      }
    },
  },

  getters: {},
};
